// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/exportdata/v1/exportdata.proto" (package "c1.api.exportdata.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { SearchAppResourcesRequest } from "../../app/v1/app_resource";
import { SearchAppEntitlementsWithRequestCatalogsRequest } from "../../requestcatalog/v1/requestcatalog";
import { TSDBMetricServiceGetTopValuesRequest } from "../../tsdb/v1/tsdb";
import { SearchGrantsExpiringBeforeRequest } from "../../app/v1/app_entitlement";
import { ListOpenExtensionTicketsRequest } from "../../task/v1/search";
import { AccessReviewSearchServiceGetProgressByAppRequest } from "../../accessreview/v1/accessreview_search";
import { AccessReviewSearchServiceCountOpenReviewsByUserRequest } from "../../accessreview/v1/accessreview_search";
import { AccessReviewSearchServiceGetReviewerDecisionsRequest } from "../../accessreview/v1/accessreview_search";
import { SubmissionsDownloadRequest } from "../../accessreview/v1/accessreview_pending";
import { SearchAppEntitlementsWithRevokableForAppUserRequest } from "../../app/v1/app_entitlement";
import { SearchUsageResourcesRequest } from "../../usage_event/v1/usage_event";
import { SearchGrantFeedRequest } from "../../app/v1/app_entitlement_user_binding";
import { SearchUsersRequest } from "../../user/v1/user";
import { AccessProfileMembershipRequest } from "../../requestcatalog/v1/requestcatalog";
import { SearchAppEntitlementsWithExpiredRequest } from "../../app/v1/app_entitlement";
import { ValidateScopeRequest } from "../../accessreview/v1/accessreview";
import { TaskSearchRequest } from "../../task/v1/search";
import { UsersWithUnspecifiedEmploymentStatusRequest } from "../../user/v1/user";
import { SearchPastGrantsRequest } from "../../app/v1/app_entitlement_user_binding";
import { AccessViolationSearchRequest } from "../../accessconflict/v1/accessviolation";
import { SearchAppsWithDeactivatedOwnerRequest } from "../../app/v1/app";
import { UsersWithoutManagerRequest } from "../../user/v1/user";
import { SearchAppUsersWithStandingHighRiskGrantsRequest } from "../../app/v1/app_entitlement_user_binding";
import { HighRiskRolesAndGrantsEntitlementsRequest } from "../../app/v1/app_resource";
import { SearchAppResourcesWithDeactivatedOwnerRequest } from "../../app/v1/app_resource";
import { SearchAppResourceRollupRequest } from "../../app/v1/app_resource";
import { SearchAppEntitlementsWithDeactivatedOwnerRequest } from "../../app/v1/app_entitlement";
import { SearchAppEntitlementsWithOneOwnerRequest } from "../../app/v1/app_entitlement";
import { SearchAppsExpandedRequest } from "../../app/v1/app";
import { SearchInactiveUsersRequest } from "../../app/v1/app_usage";
import { HighRiskUsersAndGrantsRequest } from "../../app/v1/app_user";
import { SearchOrphanedAccountsRequest } from "../../app/v1/app_user";
import { AppUsersWithoutResponsiblePartyRequest } from "../../app/v1/app_user";
import { AppUserServiceSearchRequest } from "../../app/v1/app_user";
/**
 * @generated from protobuf message c1.api.exportdata.v1.ExportDataRequest
 */
export interface ExportDataRequest {
    /**
     * @generated from protobuf field: c1.api.exportdata.v1.QueryId query_id = 1
     */
    queryId: QueryId;
    /**
     * @generated from protobuf oneof: request
     */
    request: {
        oneofKind: "appUserServiceSearchRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppUserServiceSearchRequest app_user_service_search_request = 100
         */
        appUserServiceSearchRequest: AppUserServiceSearchRequest;
    } | {
        oneofKind: "appUsersWithoutResponsiblePartyRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppUsersWithoutResponsiblePartyRequest app_users_without_responsible_party_request = 101
         */
        appUsersWithoutResponsiblePartyRequest: AppUsersWithoutResponsiblePartyRequest;
    } | {
        oneofKind: "searchOrphanedAccountsRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchOrphanedAccountsRequest search_orphaned_accounts_request = 102
         */
        searchOrphanedAccountsRequest: SearchOrphanedAccountsRequest;
    } | {
        oneofKind: "highRiskRolesAndGrantsRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.HighRiskUsersAndGrantsRequest high_risk_roles_and_grants_request = 103
         */
        highRiskRolesAndGrantsRequest: HighRiskUsersAndGrantsRequest;
    } | {
        oneofKind: "searchInactiveAppUsersRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchInactiveUsersRequest search_inactive_app_users_request = 104
         */
        searchInactiveAppUsersRequest: SearchInactiveUsersRequest;
    } | {
        oneofKind: "searchAppsExpandedRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppsExpandedRequest search_apps_expanded_request = 105
         */
        searchAppsExpandedRequest: SearchAppsExpandedRequest;
    } | {
        oneofKind: "searchAppEntitlementsWithOneOwnerRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppEntitlementsWithOneOwnerRequest search_app_entitlements_with_one_owner_request = 106
         */
        searchAppEntitlementsWithOneOwnerRequest: SearchAppEntitlementsWithOneOwnerRequest;
    } | {
        oneofKind: "searchAppEntitlementsWithDeactivatedOwnerRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppEntitlementsWithDeactivatedOwnerRequest search_app_entitlements_with_deactivated_owner_request = 107
         */
        searchAppEntitlementsWithDeactivatedOwnerRequest: SearchAppEntitlementsWithDeactivatedOwnerRequest;
    } | {
        oneofKind: "searchAppResourceRollupRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppResourceRollupRequest search_app_resource_rollup_request = 108
         */
        searchAppResourceRollupRequest: SearchAppResourceRollupRequest;
    } | {
        oneofKind: "searchAppResourcesWithDeactivatedOwnerRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppResourcesWithDeactivatedOwnerRequest search_app_resources_with_deactivated_owner_request = 109
         */
        searchAppResourcesWithDeactivatedOwnerRequest: SearchAppResourcesWithDeactivatedOwnerRequest;
    } | {
        oneofKind: "highRiskRolesAndGrantsEntitlementsRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.HighRiskRolesAndGrantsEntitlementsRequest high_risk_roles_and_grants_entitlements_request = 110
         */
        highRiskRolesAndGrantsEntitlementsRequest: HighRiskRolesAndGrantsEntitlementsRequest;
    } | {
        oneofKind: "searchAppUsersWithStandingHighRiskGrantsRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsRequest search_app_users_with_standing_high_risk_grants_request = 111
         */
        searchAppUsersWithStandingHighRiskGrantsRequest: SearchAppUsersWithStandingHighRiskGrantsRequest;
    } | {
        oneofKind: "usersWithoutManagerRequest";
        /**
         * @generated from protobuf field: c1.api.user.v1.UsersWithoutManagerRequest users_without_manager_request = 112
         */
        usersWithoutManagerRequest: UsersWithoutManagerRequest;
    } | {
        oneofKind: "searchAppsWithDeactivatedOwnerRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppsWithDeactivatedOwnerRequest search_apps_with_deactivated_owner_request = 113
         */
        searchAppsWithDeactivatedOwnerRequest: SearchAppsWithDeactivatedOwnerRequest;
    } | {
        oneofKind: "accessViolationSearchRequest";
        /**
         * @generated from protobuf field: c1.api.accessconflict.v1.AccessViolationSearchRequest access_violation_search_request = 114
         */
        accessViolationSearchRequest: AccessViolationSearchRequest;
    } | {
        oneofKind: "searchPastGrantsRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchPastGrantsRequest search_past_grants_request = 115
         */
        searchPastGrantsRequest: SearchPastGrantsRequest;
    } | {
        oneofKind: "usersWithUnspecifiedEmploymentStatusRequest";
        /**
         * @generated from protobuf field: c1.api.user.v1.UsersWithUnspecifiedEmploymentStatusRequest users_with_unspecified_employment_status_request = 116
         */
        usersWithUnspecifiedEmploymentStatusRequest: UsersWithUnspecifiedEmploymentStatusRequest;
    } | {
        oneofKind: "taskSearchRequest";
        /**
         * @generated from protobuf field: c1.api.task.v1.TaskSearchRequest task_search_request = 117
         */
        taskSearchRequest: TaskSearchRequest;
    } | {
        oneofKind: "validateScopeRequest";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.ValidateScopeRequest validate_scope_request = 118
         */
        validateScopeRequest: ValidateScopeRequest;
    } | {
        oneofKind: "searchAppEntitlementsWithExpiredRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppEntitlementsWithExpiredRequest search_app_entitlements_with_expired_request = 119
         */
        searchAppEntitlementsWithExpiredRequest: SearchAppEntitlementsWithExpiredRequest;
    } | {
        oneofKind: "accessProfileMembershipRequest";
        /**
         * @generated from protobuf field: c1.api.requestcatalog.v1.AccessProfileMembershipRequest access_profile_membership_request = 120
         */
        accessProfileMembershipRequest: AccessProfileMembershipRequest;
    } | {
        oneofKind: "searchUsersRequest";
        /**
         * @generated from protobuf field: c1.api.user.v1.SearchUsersRequest search_users_request = 121
         */
        searchUsersRequest: SearchUsersRequest;
    } | {
        oneofKind: "searchGrantFeedRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchGrantFeedRequest search_grant_feed_request = 122
         */
        searchGrantFeedRequest: SearchGrantFeedRequest;
    } | {
        oneofKind: "searchUsageResourcesRequest";
        /**
         * @generated from protobuf field: c1.api.usage_event.v1.SearchUsageResourcesRequest search_usage_resources_request = 123
         */
        searchUsageResourcesRequest: SearchUsageResourcesRequest;
    } | {
        oneofKind: "searchAppEntitlementsWithRevokableForAppUserRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppEntitlementsWithRevokableForAppUserRequest search_app_entitlements_with_revokable_for_app_user_request = 124
         */
        searchAppEntitlementsWithRevokableForAppUserRequest: SearchAppEntitlementsWithRevokableForAppUserRequest;
    } | {
        oneofKind: "submissionsDownloadRequest";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SubmissionsDownloadRequest submissions_download_request = 125
         */
        submissionsDownloadRequest: SubmissionsDownloadRequest;
    } | {
        oneofKind: "campaignReviewerDecisionsRequest";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSearchServiceGetReviewerDecisionsRequest campaign_reviewer_decisions_request = 126
         */
        campaignReviewerDecisionsRequest: AccessReviewSearchServiceGetReviewerDecisionsRequest;
    } | {
        oneofKind: "campaignOpenReviewsByUserRequest";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSearchServiceCountOpenReviewsByUserRequest campaign_open_reviews_by_user_request = 127
         */
        campaignOpenReviewsByUserRequest: AccessReviewSearchServiceCountOpenReviewsByUserRequest;
    } | {
        oneofKind: "campaignProgressByAppRequest";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSearchServiceGetProgressByAppRequest campaign_progress_by_app_request = 128
         */
        campaignProgressByAppRequest: AccessReviewSearchServiceGetProgressByAppRequest;
    } | {
        oneofKind: "listOpenExtensionTicketsRequest";
        /**
         * @generated from protobuf field: c1.api.task.v1.ListOpenExtensionTicketsRequest list_open_extension_tickets_request = 129
         */
        listOpenExtensionTicketsRequest: ListOpenExtensionTicketsRequest;
    } | {
        oneofKind: "searchGrantsExpiringBeforeRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchGrantsExpiringBeforeRequest search_grants_expiring_before_request = 130
         */
        searchGrantsExpiringBeforeRequest: SearchGrantsExpiringBeforeRequest;
    } | {
        oneofKind: "tsdbTopValuesRequest";
        /**
         * @generated from protobuf field: c1.api.tsdb.v1.TSDBMetricServiceGetTopValuesRequest tsdb_top_values_request = 131
         */
        tsdbTopValuesRequest: TSDBMetricServiceGetTopValuesRequest;
    } | {
        oneofKind: "searchAppEntitlementsWithRequestCatalogsRequest";
        /**
         * @generated from protobuf field: c1.api.requestcatalog.v1.SearchAppEntitlementsWithRequestCatalogsRequest search_app_entitlements_with_request_catalogs_request = 132
         */
        searchAppEntitlementsWithRequestCatalogsRequest: SearchAppEntitlementsWithRequestCatalogsRequest;
    } | {
        oneofKind: "searchAppResourcesRequest";
        /**
         * @generated from protobuf field: c1.api.app.v1.SearchAppResourcesRequest search_app_resources_request = 133
         */
        searchAppResourcesRequest: SearchAppResourcesRequest;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.exportdata.v1.ExportDataActionRef
 */
export interface ExportDataActionRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.exportdata.v1.ExportDataResponse
 */
export interface ExportDataResponse {
    /**
     * @generated from protobuf field: string export_data_action_id = 1
     */
    exportDataActionId: string;
}
/**
 * @generated from protobuf message c1.api.exportdata.v1.ListExportDataRequest
 */
export interface ListExportDataRequest {
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.exportdata.v1.ExportDataActionRef refs = 4
     */
    refs: ExportDataActionRef[];
}
/**
 * @generated from protobuf message c1.api.exportdata.v1.ExportDataAction
 */
export interface ExportDataAction {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.exportdata.v1.ExportDataActionState state = 2
     */
    state: ExportDataActionState;
    /**
     * @generated from protobuf field: string download_url = 3
     */
    downloadUrl: string;
    /**
     * @generated from protobuf field: c1.api.exportdata.v1.QueryId query_id = 4
     */
    queryId: QueryId;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: string display_name = 6
     */
    displayName: string;
    /**
     * @generated from protobuf field: string file_name_pattern = 7
     */
    fileNamePattern: string;
}
/**
 * @generated from protobuf message c1.api.exportdata.v1.ListExportDataResponse
 */
export interface ListExportDataResponse {
    /**
     * @generated from protobuf field: repeated c1.api.exportdata.v1.ExportDataAction list = 1
     */
    list: ExportDataAction[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf enum c1.api.exportdata.v1.QueryId
 */
export enum QueryId {
    /**
     * @generated from protobuf enum value: QUERY_ID_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: QUERY_ID_APP_USERS_WITHOUT_OWNER = 1;
     */
    APP_USERS_WITHOUT_OWNER = 1,
    /**
     * @generated from protobuf enum value: QUERY_ID_ALL_APP_USERS = 2;
     */
    ALL_APP_USERS = 2,
    /**
     * @generated from protobuf enum value: QUERY_ID_RESOURCES = 3;
     */
    RESOURCES = 3,
    /**
     * @generated from protobuf enum value: QUERY_ID_HIGH_RISK_ROLE_GRANTS_PERMANENT = 4;
     */
    HIGH_RISK_ROLE_GRANTS_PERMANENT = 4,
    /**
     * @generated from protobuf enum value: QUERY_ID_HIGH_RISK_ROLE_GRANTS_TEMPORARY = 5;
     */
    HIGH_RISK_ROLE_GRANTS_TEMPORARY = 5,
    /**
     * @generated from protobuf enum value: QUERY_ID_APP_RESOURCES_WITH_DEACTIVATED_OWNER = 6;
     */
    APP_RESOURCES_WITH_DEACTIVATED_OWNER = 6,
    /**
     * @generated from protobuf enum value: QUERY_ID_USERS_WITHOUT_MANAGER = 7;
     */
    USERS_WITHOUT_MANAGER = 7,
    /**
     * @generated from protobuf enum value: QUERY_ID_APP_USERS_NOT_LOGGED_IN_RECENTLY = 8;
     */
    APP_USERS_NOT_LOGGED_IN_RECENTLY = 8,
    /**
     * @generated from protobuf enum value: QUERY_ID_ORPHANED_ACCOUNTS = 9;
     */
    ORPHANED_ACCOUNTS = 9,
    /**
     * @generated from protobuf enum value: QUERY_ID_APP_ENTITLEMENTS_WITH_ONE_OWNER = 10;
     */
    APP_ENTITLEMENTS_WITH_ONE_OWNER = 10,
    /**
     * @generated from protobuf enum value: QUERY_ID_HIGH_RISK_ACCOUNTS = 11;
     */
    HIGH_RISK_ACCOUNTS = 11,
    /**
     * @generated from protobuf enum value: QUERY_ID_STANDING_PRIVILEGES = 12;
     */
    STANDING_PRIVILEGES = 12,
    /**
     * @generated from protobuf enum value: QUERY_ID_APPS_WITH_ONE_OWNER = 13;
     */
    APPS_WITH_ONE_OWNER = 13,
    /**
     * @generated from protobuf enum value: QUERY_ID_APPS_WITH_DEACTIVATED_OWNERS = 14;
     */
    APPS_WITH_DEACTIVATED_OWNERS = 14,
    /**
     * @generated from protobuf enum value: QUERY_ID_APP_ENTITLEMENTS_WITH_DEACTIVATED_OWNER = 15;
     */
    APP_ENTITLEMENTS_WITH_DEACTIVATED_OWNER = 15,
    /**
     * @generated from protobuf enum value: QUERY_ID_PER_APP_ACCOUNTS = 16;
     */
    PER_APP_ACCOUNTS = 16,
    /**
     * @generated from protobuf enum value: QUERY_ID_ACCESS_VIOLATIONS = 17;
     */
    ACCESS_VIOLATIONS = 17,
    /**
     * @generated from protobuf enum value: QUERY_ID_PAST_GRANTS = 18;
     */
    PAST_GRANTS = 18,
    /**
     * @generated from protobuf enum value: QUERY_ID_USERS_WITH_UNSPECIFIED_EMPLOYMENT_STATUS = 19;
     */
    USERS_WITH_UNSPECIFIED_EMPLOYMENT_STATUS = 19,
    /**
     * @generated from protobuf enum value: QUERY_ID_TASK_SEARCH = 20;
     */
    TASK_SEARCH = 20,
    /**
     * @generated from protobuf enum value: QUERY_ID_VALIDATE_SCOPE = 21;
     */
    VALIDATE_SCOPE = 21,
    /**
     * @generated from protobuf enum value: QUERY_ID_ENTITLEMENT_GRANTS = 22;
     */
    ENTITLEMENT_GRANTS = 22,
    /**
     * @generated from protobuf enum value: QUERY_ID_ACCESS_PROFILE_MEMBERSHIP = 23;
     */
    ACCESS_PROFILE_MEMBERSHIP = 23,
    /**
     * @generated from protobuf enum value: QUERY_ID_USER_SEARCH = 24;
     */
    USER_SEARCH = 24,
    /**
     * @generated from protobuf enum value: QUERY_ID_GRANT_FEED = 25;
     */
    GRANT_FEED = 25,
    /**
     * @generated from protobuf enum value: QUERY_ID_SHADOW_APPS = 26;
     */
    SHADOW_APPS = 26,
    /**
     * @generated from protobuf enum value: QUERY_ID_APP_USER_GRANTS = 27;
     */
    APP_USER_GRANTS = 27,
    /**
     * @generated from protobuf enum value: QUERY_ID_ACTIVE_EXTERNAL_ACCOUNTS = 28;
     */
    ACTIVE_EXTERNAL_ACCOUNTS = 28,
    /**
     * @generated from protobuf enum value: QUERY_ID_SUBMISSIONS_DOWNLOAD = 29;
     */
    SUBMISSIONS_DOWNLOAD = 29,
    /**
     * @generated from protobuf enum value: QUERY_ID_CAMPAIGN_REVIEWER_DECISIONS = 30;
     */
    CAMPAIGN_REVIEWER_DECISIONS = 30,
    /**
     * @generated from protobuf enum value: QUERY_ID_CAMPAIGN_OPEN_REVIEWS_BY_USER = 31;
     */
    CAMPAIGN_OPEN_REVIEWS_BY_USER = 31,
    /**
     * @generated from protobuf enum value: QUERY_ID_CAMPAIGN_PROGRESS_BY_APP = 32;
     */
    CAMPAIGN_PROGRESS_BY_APP = 32,
    /**
     * @generated from protobuf enum value: QUERY_ID_OPEN_EXTENSION_TICKETS = 33;
     */
    OPEN_EXTENSION_TICKETS = 33,
    /**
     * @generated from protobuf enum value: QUERY_ID_EXPIRING_GRANTS = 34;
     */
    EXPIRING_GRANTS = 34,
    /**
     * @generated from protobuf enum value: QUERY_ID_TSDB_TOP_VALUES = 35;
     */
    TSDB_TOP_VALUES = 35,
    /**
     * @generated from protobuf enum value: QUERY_ID_APP_ENTITLEMENTS = 36;
     */
    APP_ENTITLEMENTS = 36,
    /**
     * @generated from protobuf enum value: QUERY_ID_APP_RESOURCES = 37;
     */
    APP_RESOURCES = 37,
    /**
     * @generated from protobuf enum value: QUERY_ID_ALL_APPS = 38;
     */
    ALL_APPS = 38
}
/**
 * @generated from protobuf enum c1.api.exportdata.v1.ExportDataActionState
 */
export enum ExportDataActionState {
    /**
     * @generated from protobuf enum value: EXPORT_DATA_ACTION_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: EXPORT_DATA_ACTION_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: EXPORT_DATA_ACTION_STATE_READY = 2;
     */
    READY = 2,
    /**
     * @generated from protobuf enum value: EXPORT_DATA_ACTION_STATE_ERROR = 3;
     */
    ERROR = 3,
    /**
     * @generated from protobuf enum value: EXPORT_DATA_ACTION_STATE_DELETED = 4;
     */
    DELETED = 4,
    /**
     * @generated from protobuf enum value: EXPORT_DATA_ACTION_STATE_DELETION_ERROR = 5;
     */
    DELETION_ERROR = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class ExportDataRequest$Type extends MessageType<ExportDataRequest> {
    constructor() {
        super("c1.api.exportdata.v1.ExportDataRequest", [
            { no: 1, name: "query_id", kind: "enum", T: () => ["c1.api.exportdata.v1.QueryId", QueryId, "QUERY_ID_"] },
            { no: 100, name: "app_user_service_search_request", kind: "message", oneof: "request", T: () => AppUserServiceSearchRequest },
            { no: 101, name: "app_users_without_responsible_party_request", kind: "message", oneof: "request", T: () => AppUsersWithoutResponsiblePartyRequest },
            { no: 102, name: "search_orphaned_accounts_request", kind: "message", oneof: "request", T: () => SearchOrphanedAccountsRequest },
            { no: 103, name: "high_risk_roles_and_grants_request", kind: "message", oneof: "request", T: () => HighRiskUsersAndGrantsRequest },
            { no: 104, name: "search_inactive_app_users_request", kind: "message", oneof: "request", T: () => SearchInactiveUsersRequest },
            { no: 105, name: "search_apps_expanded_request", kind: "message", oneof: "request", T: () => SearchAppsExpandedRequest },
            { no: 106, name: "search_app_entitlements_with_one_owner_request", kind: "message", oneof: "request", T: () => SearchAppEntitlementsWithOneOwnerRequest },
            { no: 107, name: "search_app_entitlements_with_deactivated_owner_request", kind: "message", oneof: "request", T: () => SearchAppEntitlementsWithDeactivatedOwnerRequest },
            { no: 108, name: "search_app_resource_rollup_request", kind: "message", oneof: "request", T: () => SearchAppResourceRollupRequest },
            { no: 109, name: "search_app_resources_with_deactivated_owner_request", kind: "message", oneof: "request", T: () => SearchAppResourcesWithDeactivatedOwnerRequest },
            { no: 110, name: "high_risk_roles_and_grants_entitlements_request", kind: "message", oneof: "request", T: () => HighRiskRolesAndGrantsEntitlementsRequest },
            { no: 111, name: "search_app_users_with_standing_high_risk_grants_request", kind: "message", oneof: "request", T: () => SearchAppUsersWithStandingHighRiskGrantsRequest },
            { no: 112, name: "users_without_manager_request", kind: "message", oneof: "request", T: () => UsersWithoutManagerRequest },
            { no: 113, name: "search_apps_with_deactivated_owner_request", kind: "message", oneof: "request", T: () => SearchAppsWithDeactivatedOwnerRequest },
            { no: 114, name: "access_violation_search_request", kind: "message", oneof: "request", T: () => AccessViolationSearchRequest },
            { no: 115, name: "search_past_grants_request", kind: "message", oneof: "request", T: () => SearchPastGrantsRequest },
            { no: 116, name: "users_with_unspecified_employment_status_request", kind: "message", oneof: "request", T: () => UsersWithUnspecifiedEmploymentStatusRequest },
            { no: 117, name: "task_search_request", kind: "message", oneof: "request", T: () => TaskSearchRequest },
            { no: 118, name: "validate_scope_request", kind: "message", oneof: "request", T: () => ValidateScopeRequest },
            { no: 119, name: "search_app_entitlements_with_expired_request", kind: "message", oneof: "request", T: () => SearchAppEntitlementsWithExpiredRequest },
            { no: 120, name: "access_profile_membership_request", kind: "message", oneof: "request", T: () => AccessProfileMembershipRequest },
            { no: 121, name: "search_users_request", kind: "message", oneof: "request", T: () => SearchUsersRequest },
            { no: 122, name: "search_grant_feed_request", kind: "message", oneof: "request", T: () => SearchGrantFeedRequest },
            { no: 123, name: "search_usage_resources_request", kind: "message", oneof: "request", T: () => SearchUsageResourcesRequest },
            { no: 124, name: "search_app_entitlements_with_revokable_for_app_user_request", kind: "message", oneof: "request", T: () => SearchAppEntitlementsWithRevokableForAppUserRequest },
            { no: 125, name: "submissions_download_request", kind: "message", oneof: "request", T: () => SubmissionsDownloadRequest },
            { no: 126, name: "campaign_reviewer_decisions_request", kind: "message", oneof: "request", T: () => AccessReviewSearchServiceGetReviewerDecisionsRequest },
            { no: 127, name: "campaign_open_reviews_by_user_request", kind: "message", oneof: "request", T: () => AccessReviewSearchServiceCountOpenReviewsByUserRequest },
            { no: 128, name: "campaign_progress_by_app_request", kind: "message", oneof: "request", T: () => AccessReviewSearchServiceGetProgressByAppRequest },
            { no: 129, name: "list_open_extension_tickets_request", kind: "message", oneof: "request", T: () => ListOpenExtensionTicketsRequest },
            { no: 130, name: "search_grants_expiring_before_request", kind: "message", oneof: "request", T: () => SearchGrantsExpiringBeforeRequest },
            { no: 131, name: "tsdb_top_values_request", kind: "message", oneof: "request", T: () => TSDBMetricServiceGetTopValuesRequest },
            { no: 132, name: "search_app_entitlements_with_request_catalogs_request", kind: "message", oneof: "request", T: () => SearchAppEntitlementsWithRequestCatalogsRequest },
            { no: 133, name: "search_app_resources_request", kind: "message", oneof: "request", T: () => SearchAppResourcesRequest },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExportDataRequest>): ExportDataRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.queryId = 0;
        message.request = { oneofKind: undefined };
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<ExportDataRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportDataRequest): ExportDataRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.exportdata.v1.QueryId query_id */ 1:
                    message.queryId = reader.int32();
                    break;
                case /* c1.api.app.v1.AppUserServiceSearchRequest app_user_service_search_request */ 100:
                    message.request = {
                        oneofKind: "appUserServiceSearchRequest",
                        appUserServiceSearchRequest: AppUserServiceSearchRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).appUserServiceSearchRequest)
                    };
                    break;
                case /* c1.api.app.v1.AppUsersWithoutResponsiblePartyRequest app_users_without_responsible_party_request */ 101:
                    message.request = {
                        oneofKind: "appUsersWithoutResponsiblePartyRequest",
                        appUsersWithoutResponsiblePartyRequest: AppUsersWithoutResponsiblePartyRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).appUsersWithoutResponsiblePartyRequest)
                    };
                    break;
                case /* c1.api.app.v1.SearchOrphanedAccountsRequest search_orphaned_accounts_request */ 102:
                    message.request = {
                        oneofKind: "searchOrphanedAccountsRequest",
                        searchOrphanedAccountsRequest: SearchOrphanedAccountsRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).searchOrphanedAccountsRequest)
                    };
                    break;
                case /* c1.api.app.v1.HighRiskUsersAndGrantsRequest high_risk_roles_and_grants_request */ 103:
                    message.request = {
                        oneofKind: "highRiskRolesAndGrantsRequest",
                        highRiskRolesAndGrantsRequest: HighRiskUsersAndGrantsRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).highRiskRolesAndGrantsRequest)
                    };
                    break;
                case /* c1.api.app.v1.SearchInactiveUsersRequest search_inactive_app_users_request */ 104:
                    message.request = {
                        oneofKind: "searchInactiveAppUsersRequest",
                        searchInactiveAppUsersRequest: SearchInactiveUsersRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).searchInactiveAppUsersRequest)
                    };
                    break;
                case /* c1.api.app.v1.SearchAppsExpandedRequest search_apps_expanded_request */ 105:
                    message.request = {
                        oneofKind: "searchAppsExpandedRequest",
                        searchAppsExpandedRequest: SearchAppsExpandedRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).searchAppsExpandedRequest)
                    };
                    break;
                case /* c1.api.app.v1.SearchAppEntitlementsWithOneOwnerRequest search_app_entitlements_with_one_owner_request */ 106:
                    message.request = {
                        oneofKind: "searchAppEntitlementsWithOneOwnerRequest",
                        searchAppEntitlementsWithOneOwnerRequest: SearchAppEntitlementsWithOneOwnerRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).searchAppEntitlementsWithOneOwnerRequest)
                    };
                    break;
                case /* c1.api.app.v1.SearchAppEntitlementsWithDeactivatedOwnerRequest search_app_entitlements_with_deactivated_owner_request */ 107:
                    message.request = {
                        oneofKind: "searchAppEntitlementsWithDeactivatedOwnerRequest",
                        searchAppEntitlementsWithDeactivatedOwnerRequest: SearchAppEntitlementsWithDeactivatedOwnerRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).searchAppEntitlementsWithDeactivatedOwnerRequest)
                    };
                    break;
                case /* c1.api.app.v1.SearchAppResourceRollupRequest search_app_resource_rollup_request */ 108:
                    message.request = {
                        oneofKind: "searchAppResourceRollupRequest",
                        searchAppResourceRollupRequest: SearchAppResourceRollupRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).searchAppResourceRollupRequest)
                    };
                    break;
                case /* c1.api.app.v1.SearchAppResourcesWithDeactivatedOwnerRequest search_app_resources_with_deactivated_owner_request */ 109:
                    message.request = {
                        oneofKind: "searchAppResourcesWithDeactivatedOwnerRequest",
                        searchAppResourcesWithDeactivatedOwnerRequest: SearchAppResourcesWithDeactivatedOwnerRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).searchAppResourcesWithDeactivatedOwnerRequest)
                    };
                    break;
                case /* c1.api.app.v1.HighRiskRolesAndGrantsEntitlementsRequest high_risk_roles_and_grants_entitlements_request */ 110:
                    message.request = {
                        oneofKind: "highRiskRolesAndGrantsEntitlementsRequest",
                        highRiskRolesAndGrantsEntitlementsRequest: HighRiskRolesAndGrantsEntitlementsRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).highRiskRolesAndGrantsEntitlementsRequest)
                    };
                    break;
                case /* c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsRequest search_app_users_with_standing_high_risk_grants_request */ 111:
                    message.request = {
                        oneofKind: "searchAppUsersWithStandingHighRiskGrantsRequest",
                        searchAppUsersWithStandingHighRiskGrantsRequest: SearchAppUsersWithStandingHighRiskGrantsRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).searchAppUsersWithStandingHighRiskGrantsRequest)
                    };
                    break;
                case /* c1.api.user.v1.UsersWithoutManagerRequest users_without_manager_request */ 112:
                    message.request = {
                        oneofKind: "usersWithoutManagerRequest",
                        usersWithoutManagerRequest: UsersWithoutManagerRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).usersWithoutManagerRequest)
                    };
                    break;
                case /* c1.api.app.v1.SearchAppsWithDeactivatedOwnerRequest search_apps_with_deactivated_owner_request */ 113:
                    message.request = {
                        oneofKind: "searchAppsWithDeactivatedOwnerRequest",
                        searchAppsWithDeactivatedOwnerRequest: SearchAppsWithDeactivatedOwnerRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).searchAppsWithDeactivatedOwnerRequest)
                    };
                    break;
                case /* c1.api.accessconflict.v1.AccessViolationSearchRequest access_violation_search_request */ 114:
                    message.request = {
                        oneofKind: "accessViolationSearchRequest",
                        accessViolationSearchRequest: AccessViolationSearchRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).accessViolationSearchRequest)
                    };
                    break;
                case /* c1.api.app.v1.SearchPastGrantsRequest search_past_grants_request */ 115:
                    message.request = {
                        oneofKind: "searchPastGrantsRequest",
                        searchPastGrantsRequest: SearchPastGrantsRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).searchPastGrantsRequest)
                    };
                    break;
                case /* c1.api.user.v1.UsersWithUnspecifiedEmploymentStatusRequest users_with_unspecified_employment_status_request */ 116:
                    message.request = {
                        oneofKind: "usersWithUnspecifiedEmploymentStatusRequest",
                        usersWithUnspecifiedEmploymentStatusRequest: UsersWithUnspecifiedEmploymentStatusRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).usersWithUnspecifiedEmploymentStatusRequest)
                    };
                    break;
                case /* c1.api.task.v1.TaskSearchRequest task_search_request */ 117:
                    message.request = {
                        oneofKind: "taskSearchRequest",
                        taskSearchRequest: TaskSearchRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).taskSearchRequest)
                    };
                    break;
                case /* c1.api.accessreview.v1.ValidateScopeRequest validate_scope_request */ 118:
                    message.request = {
                        oneofKind: "validateScopeRequest",
                        validateScopeRequest: ValidateScopeRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).validateScopeRequest)
                    };
                    break;
                case /* c1.api.app.v1.SearchAppEntitlementsWithExpiredRequest search_app_entitlements_with_expired_request */ 119:
                    message.request = {
                        oneofKind: "searchAppEntitlementsWithExpiredRequest",
                        searchAppEntitlementsWithExpiredRequest: SearchAppEntitlementsWithExpiredRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).searchAppEntitlementsWithExpiredRequest)
                    };
                    break;
                case /* c1.api.requestcatalog.v1.AccessProfileMembershipRequest access_profile_membership_request */ 120:
                    message.request = {
                        oneofKind: "accessProfileMembershipRequest",
                        accessProfileMembershipRequest: AccessProfileMembershipRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).accessProfileMembershipRequest)
                    };
                    break;
                case /* c1.api.user.v1.SearchUsersRequest search_users_request */ 121:
                    message.request = {
                        oneofKind: "searchUsersRequest",
                        searchUsersRequest: SearchUsersRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).searchUsersRequest)
                    };
                    break;
                case /* c1.api.app.v1.SearchGrantFeedRequest search_grant_feed_request */ 122:
                    message.request = {
                        oneofKind: "searchGrantFeedRequest",
                        searchGrantFeedRequest: SearchGrantFeedRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).searchGrantFeedRequest)
                    };
                    break;
                case /* c1.api.usage_event.v1.SearchUsageResourcesRequest search_usage_resources_request */ 123:
                    message.request = {
                        oneofKind: "searchUsageResourcesRequest",
                        searchUsageResourcesRequest: SearchUsageResourcesRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).searchUsageResourcesRequest)
                    };
                    break;
                case /* c1.api.app.v1.SearchAppEntitlementsWithRevokableForAppUserRequest search_app_entitlements_with_revokable_for_app_user_request */ 124:
                    message.request = {
                        oneofKind: "searchAppEntitlementsWithRevokableForAppUserRequest",
                        searchAppEntitlementsWithRevokableForAppUserRequest: SearchAppEntitlementsWithRevokableForAppUserRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).searchAppEntitlementsWithRevokableForAppUserRequest)
                    };
                    break;
                case /* c1.api.accessreview.v1.SubmissionsDownloadRequest submissions_download_request */ 125:
                    message.request = {
                        oneofKind: "submissionsDownloadRequest",
                        submissionsDownloadRequest: SubmissionsDownloadRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).submissionsDownloadRequest)
                    };
                    break;
                case /* c1.api.accessreview.v1.AccessReviewSearchServiceGetReviewerDecisionsRequest campaign_reviewer_decisions_request */ 126:
                    message.request = {
                        oneofKind: "campaignReviewerDecisionsRequest",
                        campaignReviewerDecisionsRequest: AccessReviewSearchServiceGetReviewerDecisionsRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).campaignReviewerDecisionsRequest)
                    };
                    break;
                case /* c1.api.accessreview.v1.AccessReviewSearchServiceCountOpenReviewsByUserRequest campaign_open_reviews_by_user_request */ 127:
                    message.request = {
                        oneofKind: "campaignOpenReviewsByUserRequest",
                        campaignOpenReviewsByUserRequest: AccessReviewSearchServiceCountOpenReviewsByUserRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).campaignOpenReviewsByUserRequest)
                    };
                    break;
                case /* c1.api.accessreview.v1.AccessReviewSearchServiceGetProgressByAppRequest campaign_progress_by_app_request */ 128:
                    message.request = {
                        oneofKind: "campaignProgressByAppRequest",
                        campaignProgressByAppRequest: AccessReviewSearchServiceGetProgressByAppRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).campaignProgressByAppRequest)
                    };
                    break;
                case /* c1.api.task.v1.ListOpenExtensionTicketsRequest list_open_extension_tickets_request */ 129:
                    message.request = {
                        oneofKind: "listOpenExtensionTicketsRequest",
                        listOpenExtensionTicketsRequest: ListOpenExtensionTicketsRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).listOpenExtensionTicketsRequest)
                    };
                    break;
                case /* c1.api.app.v1.SearchGrantsExpiringBeforeRequest search_grants_expiring_before_request */ 130:
                    message.request = {
                        oneofKind: "searchGrantsExpiringBeforeRequest",
                        searchGrantsExpiringBeforeRequest: SearchGrantsExpiringBeforeRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).searchGrantsExpiringBeforeRequest)
                    };
                    break;
                case /* c1.api.tsdb.v1.TSDBMetricServiceGetTopValuesRequest tsdb_top_values_request */ 131:
                    message.request = {
                        oneofKind: "tsdbTopValuesRequest",
                        tsdbTopValuesRequest: TSDBMetricServiceGetTopValuesRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).tsdbTopValuesRequest)
                    };
                    break;
                case /* c1.api.requestcatalog.v1.SearchAppEntitlementsWithRequestCatalogsRequest search_app_entitlements_with_request_catalogs_request */ 132:
                    message.request = {
                        oneofKind: "searchAppEntitlementsWithRequestCatalogsRequest",
                        searchAppEntitlementsWithRequestCatalogsRequest: SearchAppEntitlementsWithRequestCatalogsRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).searchAppEntitlementsWithRequestCatalogsRequest)
                    };
                    break;
                case /* c1.api.app.v1.SearchAppResourcesRequest search_app_resources_request */ 133:
                    message.request = {
                        oneofKind: "searchAppResourcesRequest",
                        searchAppResourcesRequest: SearchAppResourcesRequest.internalBinaryRead(reader, reader.uint32(), options, (message.request as any).searchAppResourcesRequest)
                    };
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportDataRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.exportdata.v1.QueryId query_id = 1; */
        if (message.queryId !== 0)
            writer.tag(1, WireType.Varint).int32(message.queryId);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* c1.api.app.v1.AppUserServiceSearchRequest app_user_service_search_request = 100; */
        if (message.request.oneofKind === "appUserServiceSearchRequest")
            AppUserServiceSearchRequest.internalBinaryWrite(message.request.appUserServiceSearchRequest, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppUsersWithoutResponsiblePartyRequest app_users_without_responsible_party_request = 101; */
        if (message.request.oneofKind === "appUsersWithoutResponsiblePartyRequest")
            AppUsersWithoutResponsiblePartyRequest.internalBinaryWrite(message.request.appUsersWithoutResponsiblePartyRequest, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.SearchOrphanedAccountsRequest search_orphaned_accounts_request = 102; */
        if (message.request.oneofKind === "searchOrphanedAccountsRequest")
            SearchOrphanedAccountsRequest.internalBinaryWrite(message.request.searchOrphanedAccountsRequest, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.HighRiskUsersAndGrantsRequest high_risk_roles_and_grants_request = 103; */
        if (message.request.oneofKind === "highRiskRolesAndGrantsRequest")
            HighRiskUsersAndGrantsRequest.internalBinaryWrite(message.request.highRiskRolesAndGrantsRequest, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.SearchInactiveUsersRequest search_inactive_app_users_request = 104; */
        if (message.request.oneofKind === "searchInactiveAppUsersRequest")
            SearchInactiveUsersRequest.internalBinaryWrite(message.request.searchInactiveAppUsersRequest, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.SearchAppsExpandedRequest search_apps_expanded_request = 105; */
        if (message.request.oneofKind === "searchAppsExpandedRequest")
            SearchAppsExpandedRequest.internalBinaryWrite(message.request.searchAppsExpandedRequest, writer.tag(105, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.SearchAppEntitlementsWithOneOwnerRequest search_app_entitlements_with_one_owner_request = 106; */
        if (message.request.oneofKind === "searchAppEntitlementsWithOneOwnerRequest")
            SearchAppEntitlementsWithOneOwnerRequest.internalBinaryWrite(message.request.searchAppEntitlementsWithOneOwnerRequest, writer.tag(106, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.SearchAppEntitlementsWithDeactivatedOwnerRequest search_app_entitlements_with_deactivated_owner_request = 107; */
        if (message.request.oneofKind === "searchAppEntitlementsWithDeactivatedOwnerRequest")
            SearchAppEntitlementsWithDeactivatedOwnerRequest.internalBinaryWrite(message.request.searchAppEntitlementsWithDeactivatedOwnerRequest, writer.tag(107, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.SearchAppResourceRollupRequest search_app_resource_rollup_request = 108; */
        if (message.request.oneofKind === "searchAppResourceRollupRequest")
            SearchAppResourceRollupRequest.internalBinaryWrite(message.request.searchAppResourceRollupRequest, writer.tag(108, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.SearchAppResourcesWithDeactivatedOwnerRequest search_app_resources_with_deactivated_owner_request = 109; */
        if (message.request.oneofKind === "searchAppResourcesWithDeactivatedOwnerRequest")
            SearchAppResourcesWithDeactivatedOwnerRequest.internalBinaryWrite(message.request.searchAppResourcesWithDeactivatedOwnerRequest, writer.tag(109, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.HighRiskRolesAndGrantsEntitlementsRequest high_risk_roles_and_grants_entitlements_request = 110; */
        if (message.request.oneofKind === "highRiskRolesAndGrantsEntitlementsRequest")
            HighRiskRolesAndGrantsEntitlementsRequest.internalBinaryWrite(message.request.highRiskRolesAndGrantsEntitlementsRequest, writer.tag(110, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsRequest search_app_users_with_standing_high_risk_grants_request = 111; */
        if (message.request.oneofKind === "searchAppUsersWithStandingHighRiskGrantsRequest")
            SearchAppUsersWithStandingHighRiskGrantsRequest.internalBinaryWrite(message.request.searchAppUsersWithStandingHighRiskGrantsRequest, writer.tag(111, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.UsersWithoutManagerRequest users_without_manager_request = 112; */
        if (message.request.oneofKind === "usersWithoutManagerRequest")
            UsersWithoutManagerRequest.internalBinaryWrite(message.request.usersWithoutManagerRequest, writer.tag(112, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.SearchAppsWithDeactivatedOwnerRequest search_apps_with_deactivated_owner_request = 113; */
        if (message.request.oneofKind === "searchAppsWithDeactivatedOwnerRequest")
            SearchAppsWithDeactivatedOwnerRequest.internalBinaryWrite(message.request.searchAppsWithDeactivatedOwnerRequest, writer.tag(113, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessconflict.v1.AccessViolationSearchRequest access_violation_search_request = 114; */
        if (message.request.oneofKind === "accessViolationSearchRequest")
            AccessViolationSearchRequest.internalBinaryWrite(message.request.accessViolationSearchRequest, writer.tag(114, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.SearchPastGrantsRequest search_past_grants_request = 115; */
        if (message.request.oneofKind === "searchPastGrantsRequest")
            SearchPastGrantsRequest.internalBinaryWrite(message.request.searchPastGrantsRequest, writer.tag(115, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.UsersWithUnspecifiedEmploymentStatusRequest users_with_unspecified_employment_status_request = 116; */
        if (message.request.oneofKind === "usersWithUnspecifiedEmploymentStatusRequest")
            UsersWithUnspecifiedEmploymentStatusRequest.internalBinaryWrite(message.request.usersWithUnspecifiedEmploymentStatusRequest, writer.tag(116, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskSearchRequest task_search_request = 117; */
        if (message.request.oneofKind === "taskSearchRequest")
            TaskSearchRequest.internalBinaryWrite(message.request.taskSearchRequest, writer.tag(117, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.ValidateScopeRequest validate_scope_request = 118; */
        if (message.request.oneofKind === "validateScopeRequest")
            ValidateScopeRequest.internalBinaryWrite(message.request.validateScopeRequest, writer.tag(118, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.SearchAppEntitlementsWithExpiredRequest search_app_entitlements_with_expired_request = 119; */
        if (message.request.oneofKind === "searchAppEntitlementsWithExpiredRequest")
            SearchAppEntitlementsWithExpiredRequest.internalBinaryWrite(message.request.searchAppEntitlementsWithExpiredRequest, writer.tag(119, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.requestcatalog.v1.AccessProfileMembershipRequest access_profile_membership_request = 120; */
        if (message.request.oneofKind === "accessProfileMembershipRequest")
            AccessProfileMembershipRequest.internalBinaryWrite(message.request.accessProfileMembershipRequest, writer.tag(120, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.SearchUsersRequest search_users_request = 121; */
        if (message.request.oneofKind === "searchUsersRequest")
            SearchUsersRequest.internalBinaryWrite(message.request.searchUsersRequest, writer.tag(121, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.SearchGrantFeedRequest search_grant_feed_request = 122; */
        if (message.request.oneofKind === "searchGrantFeedRequest")
            SearchGrantFeedRequest.internalBinaryWrite(message.request.searchGrantFeedRequest, writer.tag(122, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.usage_event.v1.SearchUsageResourcesRequest search_usage_resources_request = 123; */
        if (message.request.oneofKind === "searchUsageResourcesRequest")
            SearchUsageResourcesRequest.internalBinaryWrite(message.request.searchUsageResourcesRequest, writer.tag(123, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.SearchAppEntitlementsWithRevokableForAppUserRequest search_app_entitlements_with_revokable_for_app_user_request = 124; */
        if (message.request.oneofKind === "searchAppEntitlementsWithRevokableForAppUserRequest")
            SearchAppEntitlementsWithRevokableForAppUserRequest.internalBinaryWrite(message.request.searchAppEntitlementsWithRevokableForAppUserRequest, writer.tag(124, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.SubmissionsDownloadRequest submissions_download_request = 125; */
        if (message.request.oneofKind === "submissionsDownloadRequest")
            SubmissionsDownloadRequest.internalBinaryWrite(message.request.submissionsDownloadRequest, writer.tag(125, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.AccessReviewSearchServiceGetReviewerDecisionsRequest campaign_reviewer_decisions_request = 126; */
        if (message.request.oneofKind === "campaignReviewerDecisionsRequest")
            AccessReviewSearchServiceGetReviewerDecisionsRequest.internalBinaryWrite(message.request.campaignReviewerDecisionsRequest, writer.tag(126, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.AccessReviewSearchServiceCountOpenReviewsByUserRequest campaign_open_reviews_by_user_request = 127; */
        if (message.request.oneofKind === "campaignOpenReviewsByUserRequest")
            AccessReviewSearchServiceCountOpenReviewsByUserRequest.internalBinaryWrite(message.request.campaignOpenReviewsByUserRequest, writer.tag(127, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.AccessReviewSearchServiceGetProgressByAppRequest campaign_progress_by_app_request = 128; */
        if (message.request.oneofKind === "campaignProgressByAppRequest")
            AccessReviewSearchServiceGetProgressByAppRequest.internalBinaryWrite(message.request.campaignProgressByAppRequest, writer.tag(128, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.ListOpenExtensionTicketsRequest list_open_extension_tickets_request = 129; */
        if (message.request.oneofKind === "listOpenExtensionTicketsRequest")
            ListOpenExtensionTicketsRequest.internalBinaryWrite(message.request.listOpenExtensionTicketsRequest, writer.tag(129, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.SearchGrantsExpiringBeforeRequest search_grants_expiring_before_request = 130; */
        if (message.request.oneofKind === "searchGrantsExpiringBeforeRequest")
            SearchGrantsExpiringBeforeRequest.internalBinaryWrite(message.request.searchGrantsExpiringBeforeRequest, writer.tag(130, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.tsdb.v1.TSDBMetricServiceGetTopValuesRequest tsdb_top_values_request = 131; */
        if (message.request.oneofKind === "tsdbTopValuesRequest")
            TSDBMetricServiceGetTopValuesRequest.internalBinaryWrite(message.request.tsdbTopValuesRequest, writer.tag(131, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.requestcatalog.v1.SearchAppEntitlementsWithRequestCatalogsRequest search_app_entitlements_with_request_catalogs_request = 132; */
        if (message.request.oneofKind === "searchAppEntitlementsWithRequestCatalogsRequest")
            SearchAppEntitlementsWithRequestCatalogsRequest.internalBinaryWrite(message.request.searchAppEntitlementsWithRequestCatalogsRequest, writer.tag(132, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.SearchAppResourcesRequest search_app_resources_request = 133; */
        if (message.request.oneofKind === "searchAppResourcesRequest")
            SearchAppResourcesRequest.internalBinaryWrite(message.request.searchAppResourcesRequest, writer.tag(133, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.exportdata.v1.ExportDataRequest
 */
export const ExportDataRequest = new ExportDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportDataActionRef$Type extends MessageType<ExportDataActionRef> {
    constructor() {
        super("c1.api.exportdata.v1.ExportDataActionRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExportDataActionRef>): ExportDataActionRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ExportDataActionRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportDataActionRef): ExportDataActionRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportDataActionRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.exportdata.v1.ExportDataActionRef
 */
export const ExportDataActionRef = new ExportDataActionRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportDataResponse$Type extends MessageType<ExportDataResponse> {
    constructor() {
        super("c1.api.exportdata.v1.ExportDataResponse", [
            { no: 1, name: "export_data_action_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExportDataResponse>): ExportDataResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.exportDataActionId = "";
        if (value !== undefined)
            reflectionMergePartial<ExportDataResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportDataResponse): ExportDataResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string export_data_action_id */ 1:
                    message.exportDataActionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportDataResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string export_data_action_id = 1; */
        if (message.exportDataActionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.exportDataActionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.exportdata.v1.ExportDataResponse
 */
export const ExportDataResponse = new ExportDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExportDataRequest$Type extends MessageType<ListExportDataRequest> {
    constructor() {
        super("c1.api.exportdata.v1.ListExportDataRequest", [
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExportDataActionRef }
        ]);
    }
    create(value?: PartialMessage<ListExportDataRequest>): ListExportDataRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<ListExportDataRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExportDataRequest): ListExportDataRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.exportdata.v1.ExportDataActionRef refs */ 4:
                    message.refs.push(ExportDataActionRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExportDataRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.exportdata.v1.ExportDataActionRef refs = 4; */
        for (let i = 0; i < message.refs.length; i++)
            ExportDataActionRef.internalBinaryWrite(message.refs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.exportdata.v1.ListExportDataRequest
 */
export const ListExportDataRequest = new ListExportDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportDataAction$Type extends MessageType<ExportDataAction> {
    constructor() {
        super("c1.api.exportdata.v1.ExportDataAction", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "state", kind: "enum", T: () => ["c1.api.exportdata.v1.ExportDataActionState", ExportDataActionState, "EXPORT_DATA_ACTION_STATE_"] },
            { no: 3, name: "download_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "query_id", kind: "enum", T: () => ["c1.api.exportdata.v1.QueryId", QueryId, "QUERY_ID_"] },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "file_name_pattern", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExportDataAction>): ExportDataAction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.state = 0;
        message.downloadUrl = "";
        message.queryId = 0;
        message.displayName = "";
        message.fileNamePattern = "";
        if (value !== undefined)
            reflectionMergePartial<ExportDataAction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportDataAction): ExportDataAction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* c1.api.exportdata.v1.ExportDataActionState state */ 2:
                    message.state = reader.int32();
                    break;
                case /* string download_url */ 3:
                    message.downloadUrl = reader.string();
                    break;
                case /* c1.api.exportdata.v1.QueryId query_id */ 4:
                    message.queryId = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* string display_name */ 6:
                    message.displayName = reader.string();
                    break;
                case /* string file_name_pattern */ 7:
                    message.fileNamePattern = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportDataAction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* c1.api.exportdata.v1.ExportDataActionState state = 2; */
        if (message.state !== 0)
            writer.tag(2, WireType.Varint).int32(message.state);
        /* string download_url = 3; */
        if (message.downloadUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.downloadUrl);
        /* c1.api.exportdata.v1.QueryId query_id = 4; */
        if (message.queryId !== 0)
            writer.tag(4, WireType.Varint).int32(message.queryId);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 6; */
        if (message.displayName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.displayName);
        /* string file_name_pattern = 7; */
        if (message.fileNamePattern !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.fileNamePattern);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.exportdata.v1.ExportDataAction
 */
export const ExportDataAction = new ExportDataAction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListExportDataResponse$Type extends MessageType<ListExportDataResponse> {
    constructor() {
        super("c1.api.exportdata.v1.ListExportDataResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExportDataAction },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListExportDataResponse>): ListExportDataResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListExportDataResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListExportDataResponse): ListExportDataResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.exportdata.v1.ExportDataAction list */ 1:
                    message.list.push(ExportDataAction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListExportDataResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.exportdata.v1.ExportDataAction list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ExportDataAction.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.exportdata.v1.ListExportDataResponse
 */
export const ListExportDataResponse = new ListExportDataResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.exportdata.v1.ExportDataService
 */
export const ExportDataService = new ServiceType("c1.api.exportdata.v1.ExportDataService", [
    { name: "ExportData", options: { "authz.method": { role: "EDITOR" } }, I: ExportDataRequest, O: ExportDataResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: ListExportDataRequest, O: ListExportDataResponse }
]);
